module.exports = __webpack_public_path__ + "static/assets/59a49600797479345429e4774af688c4.png";